/**
 * Central export file for all form section components
 * Simplifies imports throughout the application
 */

export { default as CommonFields } from './CommonFields';
export { default as AnnuityFormSection } from './AnnuityFormSection';
export { default as AnnuityProductSection } from './AnnuityProductSection';
export { default as AnnuityPlanSection } from './AnnuityPlanSection';
export { default as ProposedInsuredSection } from './ProposedInsuredSection';
export { default as LifeDemographicsSection } from './LifeDemographicsSection';
export { default as LifeProductSection } from './LifeProductSection';
export { default as LifePlanSection } from './LifePlanSection';
export { default as AgentInformationSection } from './AgentInformationSection';
